import { render, staticRenderFns } from "./PdfIcon.vue?vue&type=template&id=b85b6068&"
import script from "./PdfIcon.vue?vue&type=script&lang=ts&"
export * from "./PdfIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports